import { render, staticRenderFns } from "./guard.vue?vue&type=template&id=9fa7bf0e&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "guard.vue"
export default component.exports